<template>
    <Notivue v-slot="item">
        <Notification :item :theme="pastelTheme" :icons="outlinedIcons" />
    </Notivue>
    <v-app :style="{ background: $vuetify.theme.background }">
        <!-- Loading overlay while auth is initializing -->
        <v-overlay :model-value="!isInitialized && route.name !== 'Maintenance'" class="align-center justify-center"
            persistent>
            <v-progress-circular indeterminate size="76" width="5" color="primary" />
        </v-overlay>

        <template v-if="isInitialized || route.name === 'Maintenance'">
            <NavigationDrawer v-if="isConnected"></NavigationDrawer>
            <div v-if="get('ENV') !== 'production'"
                class="position-fixed d-flex align-end right-0 bottom-0 me-4 text-primary"
                style="z-index: 10000; pointer-events: none">
                <div v-if="user?.id">
                    Account type : {{ user.accountType }}
                </div>
                <v-divider vertical class="mx-1"></v-divider>
                <div>
                    {{ width }}x{{ height }} <br />
                    {{ orientation }} | {{ name }}
                </div>
            </div>
            <v-main
                :style="`--v-layout-left: ${layoutLeft}px; --v-layout-top: ${layoutTop}px; --v-layout-bottom: ${layoutBottom}px`">
                <router-view />
            </v-main>
        </template>
    </v-app>
</template>

<script setup>
import { Notivue, Notification, pastelTheme, outlinedIcons } from "notivue";

const router = useRouter();
const route = useRoute();

const { setupAuth, authStore } = useAuth();
const { isConnected, isAdmin, isInitialized, user } = storeToRefs(authStore);
const { get } = useParameters();

// Meta
useHead({
    title: "Nebulone",
    meta: [{ name: "description", content: "Plateforme de mise en relation de télépilote de drone" }],
});

// Setup cookie listener for auth state changes (auth check is handled by router guard)
setupAuth();

// Layout
const { name, mobile, height, width } = useDisplay();
const { orientation } = useScreenOrientation();

const smallLandscapeScreen = computed(
    () => orientation.value === "landscape-primary" && ["xs", "sm"].includes(name.value),
);
provide("smallLandscapeScreen", smallLandscapeScreen);

const layoutLeft = computed(() => {
    if (!isConnected.value) return 0;

    if (["xs"].includes(name.value) && orientation.value === "portrait-primary") return 0;

    if (["xs", "sm"].includes(name.value)) return 75;

    return 95;
});
const layoutTop = computed(() => {
    if (["Messages", "Maintenance"].includes(route.name)) return 0;

    if (smallLandscapeScreen.value || name.value === "xs") return 0;

    return 50;
});
const layoutBottom = computed(() => {
    if (["xs"].includes(name.value) && orientation.value === "portrait-primary") return 56;
    return 0;
});
</script>

<style lang="scss">
@use "sass:map";
@use "@/styles/settings";

:root {
    --nv-z: 9999;
}

.v-application {
    font-size: 100%;

    @media (max-width: calc(map.get(settings.$grid-breakpoints, "lg") - 1px)) {
        font-size: 90%;
    }
}

::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

::-webkit-scrollbar-track {
    background: transparent;
}

::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.1);
}

:hover::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
}

:hover::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.3);
}

body[page="Messages"]::-webkit-scrollbar {
    display: none;
}
</style>
